module.exports = __webpack_public_path__ + "static/img/icon.71ed19e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/icon.png
// module id = 389
// module chunks = 8